import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: 'What is the success rate of IVF treatments at your clinic?',
    answer: "Our success rates vary based on factors such as age, diagnosis, and previous treatments. For women under 35, our clinical pregnancy rate per embryo transfer is approximately 65%. During your consultation, we'll discuss your personal prognosis based on your specific situation."
  }, {
    question: 'How long does the IVF process take from start to finish?',
    answer: 'A typical IVF cycle takes about 4-6 weeks from start to embryo transfer. This includes ovarian stimulation (10-12 days), egg retrieval, fertilization, and embryo culture (3-5 days). The two-week wait for pregnancy results follows. Your specific timeline may vary based on your treatment protocol.'
  }, {
    question: 'What is the cost of IVF treatment?',
    answer: 'The cost varies depending on your specific treatment plan and any additional procedures needed. We offer transparent pricing and financial counseling to help you understand all costs before beginning treatment. We also work with several financing options and insurance providers.'
  }, {
    question: 'Is IVF painful?',
    answer: "Most patients experience minimal discomfort during IVF. The hormone injections involve small needles similar to those used for insulin. The egg retrieval procedure is performed under sedation, so you won't feel pain during the process. Some mild cramping afterward is normal and can be managed with over-the-counter pain relievers."
  }, {
    question: 'What age is too old for IVF?',
    answer: "While age does affect fertility, there's no absolute cutoff age for IVF. Success rates decline with age, particularly after 40, but we evaluate each patient individually. Some women may be candidates for donor eggs, which significantly increases success rates regardless of age."
  }, {
    question: 'How do you support patients emotionally through the IVF process?',
    answer: 'We recognize the emotional challenges of fertility treatments. Our clinic provides access to dedicated fertility counselors, support groups, and resources to help you navigate the emotional aspects of your journey. Our staff is also trained to provide compassionate support throughout your treatment.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="py-20 bg-gradient-to-b from-slate-50 to-white" data-id="element-283">
      <div className="container mx-auto px-4" data-id="element-284">
        <div className="text-center mb-16" data-id="element-285">
          <div className="inline-block bg-blue-50 rounded-full px-4 py-2 mb-4" data-id="element-286">
            <span className="text-blue-700 font-semibold text-sm" data-id="element-287">FAQ</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-288">
            Frequently Asked <span className="text-blue-600" data-id="element-289">Questions</span>
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto text-lg" data-id="element-290">
            Find answers to common questions about fertility treatments and our
            services.
          </p>
        </div>
        <div className="max-w-3xl mx-auto" data-id="element-291">
          {faqs.map((faq, index) => <div key={index} className="mb-4" data-id="element-292">
              <button onClick={() => toggleFAQ(index)} className={`flex justify-between items-center w-full text-left p-6 rounded-2xl transition-all duration-300 ${openIndex === index ? 'bg-blue-50 border-2 border-blue-200' : 'bg-white border-2 border-slate-200 hover:border-blue-200'}`} data-id="element-293">
                <span className="font-bold text-slate-900 pr-4" data-id="element-294">
                  {faq.question}
                </span>
                <div className={`flex-shrink-0 p-2 rounded-full transition-colors ${openIndex === index ? 'bg-blue-600' : 'bg-slate-200'}`} data-id="element-295">
                  {openIndex === index ? <MinusIcon className="text-white" size={20} data-id="element-296" /> : <PlusIcon className="text-slate-600" size={20} data-id="element-297" />}
                </div>
              </button>
              {openIndex === index && <div className="p-6 bg-blue-50 rounded-b-2xl mt-[-8px] border-2 border-t-0 border-blue-200" data-id="element-298">
                  <p className="text-slate-600 leading-relaxed" data-id="element-299">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
        <div className="mt-12 text-center" data-id="element-300">
          <p className="text-slate-600 text-lg mb-6" data-id="element-301">
            Don't see your question here?
          </p>
          <a href="/contact" className="inline-block bg-blue-600 text-white px-8 py-4 rounded-full hover:bg-blue-700 transition-all duration-300 shadow-lg hover:shadow-blue-600/30 hover:scale-105 font-semibold" data-id="element-302">
            Ask Our Team
          </a>
        </div>
      </div>
    </section>;
}